import { Button, Logo } from "@roole/package-webtoolkit-b2b";
import "@roole/package-webtoolkit-b2b/build/styles/output.tailwind.css";
import "../../styles/index.tailwind.css";
import styled from "styled-components";
import DownloadApplicationIllu from "./DownloadApplicationIllu.svg";
import { useEffect } from "react";
import { useGTM } from "../../hooks";

const CardContent = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 600px;

  @media (min-width: 600px) {
    gap: 80px;
  }

  @media (max-width: 600px) {
    height: 100%;
    justify-content: space-evenly;
  }
`;

const CardTopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
`;

export const DownloadApplication: React.FC = () => {
  const { sendEvent, environnement } = useGTM();

  useEffect(() => {
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    sendEvent("page_view", {
      is_dark_mode: darkModeQuery.matches,
      page_category: "landing_qr_code",
      source: "docusing_ep",
      environnement,
    });
  }, []);

  return (
    <div
      style={{ height: "100vh" }}
      className="bg-sub-brand-light w-screen flex flex-col justify-center items-center px-XS "
    >
      <CardContent>
        <CardTopContent>
          <div className="flex flex-col justify-center items-center gap-XL ">
            <Logo color="icons-dark" size={{ type: "width", value: 100 }} />
            <img
              src={DownloadApplicationIllu}
              alt="Télécharger application illu"
            />
          </div>

          <div className="flex flex-col gap-XS">
            <h3 className="heading-3 text-center">
              Votre contrat est signé, bienvenue{" "}
              <span className="whitespace-nowrap">chez Roole !</span>
            </h3>

            <p className="body-medium text-center">
              Téléchargez dès maintenant l’<b>application Roole Premium</b> pour
              consulter vos garanties, déclarer un sinistre, suivre son avancée
              et profiter de tous les bons plans et services Roole.
            </p>
          </div>
        </CardTopContent>

        <div className="self-center">
          <Button
            label="Télécharger l'application"
            size="large"
            variant="primary-brand"
            onClick={() => {
              sendEvent("telecharger_application", {
                page_category: "landing_qr_code",
              });

              window.open("https://link.roole.fr/app/home", "_blank");
            }}
          />
        </div>
      </CardContent>
    </div>
  );
};
